<template>
    <div class="card-container" v-html="text"/>
</template>

<script>
export default {
    name: 'Card',
    props: {
        text: {
            type: String
        }
    }
}
</script>
